import Abertas from '../screens/Abertas';

const route = [
  {
    path: '/abertas',
    main: Abertas,
  },
];

export default route;
